import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/base/basecomponent';
import { MoveService } from '@modules/move-notification/services/move.service';
import { FaultNotificationService } from '@modules/fault-notification/services/fault-notification.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export enum ThankYouType {
  Fault = 1,
  Move
}


@Component({
  selector: 'thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent extends BaseComponent implements OnInit {
  
  public text: string;
  public faultStatus: number;

  constructor(
    private moveService: MoveService,
    private faultService: FaultNotificationService
  ) {
    super();
  }

  ngOnInit(): void {

    let type: ThankYouType = window.history.state.type;
    this.faultStatus = window.history.state.faultStatus;

    let lang: HttpParams = new HttpParams().set('lang', this.translate.currentLang);

    let text$: Observable<string>;

    if (type === ThankYouType.Fault)
      text$ = this.faultService.getFaultThanks(lang);
    else if (type === ThankYouType.Move)
      text$ = this.moveService.getMoveThanks(lang);

    text$?.subscribe(text => {
      this.text = text;
    }, error => {
      this.errorHandler.applyGeneralErrors(error);
    })
  }

}
